import {
  InvestmentFormElement,
  projectionType,
  InvestmentTypeMapping,
} from "../helpers/constant";
import { mapGetters, mapActions } from "vuex";
import { CommonHelper } from "../helpers";
import InvestmentProjection from "../models/investmentProjection";
import {
  GET_INVESTMENT_ENTITY_INFORMATION,
  SET_PROJECTION_MODEL,
} from "../helpers/vuex-constants";
import BaseIceIntegration from "./ice-integration";

import ICEAdvanceInvestmentType from "../models/iceInvestmentAdvanceType";

import { AdvanceInvestmentFilter, IceRowType } from "../helpers/constant";
export default {
  computed: {
    ...mapGetters("investment", {
      ClientsInfo: GET_INVESTMENT_ENTITY_INFORMATION,
    }),
  },
  mixins: [BaseIceIntegration],
  methods: {
    ...mapActions("investment", {
      setIceProjectionModel: SET_PROJECTION_MODEL,
    }),
    prepareAPIModel(baselineData) {
      let inputClientData = this.prepareBaseAPIModel();

      inputClientData.ProjectionInfo = this.fillAllClientInfo(baselineData);
      return inputClientData;
    },
    fillAllClientInfo(baselineData) {
      let InvestmentInfo = [];
      for (let i = 0; i < baselineData.length; i++) {
        InvestmentInfo.push(this.fillBasicInvestmentInfo(baselineData[i]));
      }
      return InvestmentInfo;
    },
    fillBasicInvestmentInfo(formModel) {
      let ClientInvestment = {};
      ClientInvestment.UniqueId = formModel.uniqueId;
      ClientInvestment.EntityType = formModel.ownerEntityType;
      ClientInvestment.TypeId =
        formModel.investmentClassID == InvestmentTypeMapping.AUS.key
          ? InvestmentTypeMapping.AUS.value
          : formModel.investmentClassID == InvestmentTypeMapping.ITP.key
          ? InvestmentTypeMapping.ITP.value
          : formModel.investmentClassID == InvestmentTypeMapping.MFD.key
          ? InvestmentTypeMapping.MFD.value
          : formModel.investmentClassID == InvestmentTypeMapping.BNK.key
          ? InvestmentTypeMapping.BNK.value
          : formModel.investmentClassID == InvestmentTypeMapping.OTH.key
          ? InvestmentTypeMapping.OTH.value
          : formModel.investmentClassID == InvestmentTypeMapping.DPT.key
          ? InvestmentTypeMapping.DPT.value
          : 0;
      ClientInvestment.ProjectionType = projectionType.Investemnt;
      ClientInvestment.Projections = this.fillBasicProjectionInfo(
        formModel,
        InvestmentFormElement
      );
      ClientInvestment.Projections = ClientInvestment.Projections.concat(
        this.fillAdvanceDetails(formModel.advancedetails, formModel.description)
      );
      return ClientInvestment;
    },

    getEloquaFormModel() {
      return {
        ownerEntityType: this.baselineFilterObject.ownerEntityType,
        maturityDate: this.baselineFilterObject.maturityDate,
        isRenewAuto: this.baselineFilterObject.isRenewAuto,
        investmentClassID: this.baselineFilterObject.investmentClassID,
        amount: this.baselineFilterObject.amount,
        riskProfileId: this.baselineFilterObject.riskProfileId,
        projectionYear: this.projectionYear,
        incomeRate: this.baselineFilterObject.incomeRate,
        growthRate: this.baselineFilterObject.growthRate,
        frankingRate: this.baselineFilterObject.frankingRate,
        contributionAmount: this.baselineFilterObject.contributionAmount,
        durationTypeId: this.baselineFilterObject.durationTypeId,
        isDRP: this.baselineFilterObject.isDRP ? 1 : 0,
        description: this.baselineFilterObject.description,
        uniqueId: CommonHelper.uuidv4(),
        advancedetails: this.getAdvanceFilterDetails(
          CommonHelper.ConvertObjectIntoApiModel(
            this.baselineFilterObject.advancedetails
          )
        ),
      };
    },

    getAdvanceFilterDetails(advancedetails) {
      let userEnteredData = [];
      for (let i = 0; i < advancedetails.length; i++) {
        let row = {};
        if (advancedetails[i].typeId == AdvanceInvestmentFilter.Return) {
          row = this.addICERow(
            advancedetails[i],
            advancedetails[i].amount,
            IceRowType.Investment_Income_Rate
          );
          userEnteredData.push(row);
          row = this.addICERow(
            advancedetails[i],
            advancedetails[i].amount1,
            IceRowType.Investment_Growth_Rate
          );
          userEnteredData.push(row);
          row = this.addICERow(
            advancedetails[i],
            advancedetails[i].amount2,
            IceRowType.Investment_Franking_Rate
          );
          userEnteredData.push(row);
        } else if (
          advancedetails[i].typeId == AdvanceInvestmentFilter.MarketCrash
        ) {
          row = this.addICERow(
            advancedetails[i],
            advancedetails[i].amount,
            IceRowType.Investment_MarketDrop
          );
          userEnteredData.push(row);
          row = this.addICERow(
            advancedetails[i],
            advancedetails[i].amount1,
            IceRowType.Investment_MarketDropRecoveryPercent
          );
          userEnteredData.push(row);
        } else {
          row = this.addICERow(
            advancedetails[i],
            advancedetails[i].amount,
            CommonHelper.defaultIntValue(advancedetails[i].subTypeId)
          );
          userEnteredData.push(row);
        }
      }

      return userEnteredData;
    },
    addICERow(GridRow, amount, subTypeId) {
      let row = {};
      row.typeId = GridRow.typeId
        ? CommonHelper.defaultIntValue(GridRow.typeId)
        : 0;
      row.subTypeId = subTypeId;
      row.amount = CommonHelper.defaultIntValue(
        amount.value ? amount.value : amount
      );
      row.endDate = GridRow.endDate
        ? CommonHelper.defaultStringValue(GridRow.endDate)
        : "";
      row.accountNumber = "";
      row.endDateType = GridRow.endDateType
        ? CommonHelper.defaultIntValue(GridRow.endDateType)
        : 0;
      row.startDate = GridRow.startDate
        ? CommonHelper.defaultStringValue(GridRow.startDate)
        : "";
      row.startDateType = GridRow.startDateType
        ? CommonHelper.defaultIntValue(GridRow.startDateType)
        : 0;
      row.index = GridRow.index
        ? CommonHelper.defaultIntValue(GridRow.index)
        : 0;
      row.frequency = GridRow.frequency
        ? CommonHelper.defaultIntValue(GridRow.frequency)
        : 0;
      row.effectiveAsON = GridRow.effectiveAsON
        ? CommonHelper.defaultIntValue(GridRow.effectiveAsON)
        : 0;

      return row;
    },
    async getProjectionResult() {
      this.chartGraphData = [];
      let baselineData = this.getEloquaFormModel();
      let userInput = [];
      userInput.push(baselineData);
      let apiModel = this.prepareAPIModel(userInput);
      this.setLoaderVisibility(true);
      let iceResponseData = await this.getProjection(apiModel);

      this.setLoaderVisibility(false);
      if (iceResponseData.iceInput) {
        this.setIceProjectionModel(iceResponseData);
      }
      let projectionData =
        InvestmentProjection.setInvestmentProjections(iceResponseData);
      if (projectionData.length == 0) {
        return;
      }
      this.setInvestmentChartModel(
        this.setInvestmentModel(projectionData, baselineData)
      );
    },
    fillAdvanceDetails(advanceDetailsOption, investmentdescription) {
      let advanceLoanInfo = [];
      advanceLoanInfo = ICEAdvanceInvestmentType.setInvestmentAdvanceType(
        advanceDetailsOption,
        investmentdescription
      );
      return advanceLoanInfo;
    },
    setInvestmentModel(projectionData, baselineData) {
      let reponseData = {
        projectedBalance: CommonHelper.convertIntoCurrencyWithoutDecimal(
          projectionData.investmentProjectionResult[0].projectedValuePeriod
        ),
        cumulativeReturn: CommonHelper.convertIntoCurrencyWithoutDecimal(
          projectionData.investmentProjectionResult[0].totalIncomeReturn +
            projectionData.investmentProjectionResult[0].totalGrowthReturn
        ),
        netContribution: CommonHelper.convertIntoCurrencyWithoutDecimal(
          projectionData.investmentProjectionResult[0].totalContributions +
            projectionData.investmentProjectionResult[0].totalWithdrawals +
            projectionData.investmentProjectionResult[0].totalPlatformFees +
            projectionData.investmentProjectionResult[0].totalAdviceFees +
            projectionData.investmentProjectionResult[0].totalOtherFees
        ),
        contributionWithdrawalGraphData:
          InvestmentProjection.getContributionWithdrawalGraph(
            projectionData.investmentProjectionResult[0].investmentProjection
          ),
        balanceGraphData: InvestmentProjection.getBalanceGraphData(
          projectionData.investmentProjectionResult[0].investmentProjection,
          baselineData
        ),
        ReturnFeesGraphData: InvestmentProjection.getReturnFeesData(
          projectionData.investmentProjectionResult[0].investmentProjection,
          baselineData
        ),
      };
      return reponseData;
    },
  },
};
